import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Button, Modal, Form, Offcanvas } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';
import CreatableSelect from 'react-select/creatable';
import { FaPlus } from 'react-icons/fa';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const API_URL = `${backendUrl}/api/systemtenant`;
const CATEGORY_API_URL = `${backendUrl}/api/categories?type=tenant`;

const SystemTenant = () => {
    const [Tenants, setTenants] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '' });
    const [isEdit, setIsEdit] = useState(false);
    const [selectedExpenseType, setSelectedExpenseType] = useState(null);
    const didFetchRef = useRef(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [errors, setErrors] = useState({});
    const WithEditPermission = withPermission(({ children }) => children, ['systemtenant-edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['systemtenant-delete']);
    const WithCreatePermission = withPermission(({ children }) => children, ['systemtenant-create']);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [categories, setCategories] = useState([]);
    const [showCategoryModal, setShowCategoryModal] = useState(false);

    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchTenants(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };

    const fetchTenants = async (page = 1) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            const response = await axios.get(`${API_URL}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    page,
                    search: searchQuery,
                },
            });
            setTenants(response.data.tenant.data);
            setPageCount(response.data.tenant.last_page);
            setCurrentPage(response.data.tenant.current_page);


        } catch (error) {
            console.error('Error fetching Tenants:', error);
        }
    };

    const fetchCategories = async () => {
        try {
            const token = JSON.parse(localStorage.getItem('user-info'))?.token;
            const response = await axios.get(CATEGORY_API_URL, {
                headers: { Authorization: `Bearer ${token}` },
                skipLoader: true,

            });
            setCategories(response.data.category);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };
    const handleAddExpenseType = () => {
        setFormData({ name: '', url: '', auth: false, });
        setIsEdit(false);
        setSelectedExpenseType(null);
        setShowModal(true);
        setErrors({});

    };

    const handleEditExpenseType = (tenanttype) => {
        setFormData({
            ...tenanttype,
            auth: tenanttype.auth === 'true' ? true : false,         
        });
        setIsEdit(true);
        setSelectedExpenseType(tenanttype);
        setShowModal(true);
        setErrors({});
    };


    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');

                    const token = userInfo?.token;
                    await axios.delete(`${API_URL}/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });
                    setTenants(Tenants.filter(tenanttype => tenanttype.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The tenanttype has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting tenanttype:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete tenanttype. Please try again.",
                        "error"
                    );
                }
            }
        });

    };

    // const handleInputChange = (e) => {
    //     const { name, value} = e.target;

    //     // Ensure that we handle the radio button correctly
    //     if (name === "status") {
    //         setFormData((prev) => ({
    //             ...prev,
    //             status: value,
    //         }));
    //     } 
    //     setErrors((prevErrors) => ({
    //         ...prevErrors,
    //         [name]: undefined,
    //     }));
    // };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Update the form state
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
        }));
    };




    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        fetchTenants(newPage);
    };

    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);
    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';




        return newErrors;
    };
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');

        const token = userInfo?.token;
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return; // Stop here if validation fails
        }
        try {
            if (isEdit) {
                const response = await axios.put(`${API_URL}/${selectedExpenseType.id}`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setTenants(Tenants.map(ind => (ind.id === selectedExpenseType.id ? response.data.tenant : ind)));
            } else {
                const response = await axios.post(API_URL, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setTenants([...Tenants, response.data.tenant]);
            }
            setShowModal(false);
        } catch (error) {
            {
                console.error('Unexpected error: ', error);
            }
        }
    };

    const filteredTenants = Tenants.filter(tenanttype => !tenanttype.parent_id);
    const handleCategoryChange = (selectedOption) => {
        setFormData((prev) => ({ ...prev, category_id: selectedOption.value }));
    };

    const handleCategoryCreate = async (inputValue) => {
        try {
            const token = JSON.parse(localStorage.getItem('user-info'))?.token;
            const response = await axios.post(CATEGORY_API_URL, { name: inputValue }, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const newCategory = response.data.category;
            setCategories([...categories, newCategory]);
            setFormData((prev) => ({ ...prev, category_id: newCategory.id }));
        } catch (error) {
            console.error('Error adding category:', error);
        }
    };


    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid ">
                    <div className="row w-100">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Tenant</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        {/* <li className="breadcrumb-item"><a href="javascript:void(0);">ExpenseType</a></li> */}
                                        {/* <li className="breadcrumb-item active">ExpenseType List</li> */}
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control font-size-12"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>

                                        <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                onClick={handleAddExpenseType} data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Add ExpenseType"
                                            >
                                                <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                                            </button>
                                        </WithCreatePermission>
                                    </div>
                                    <table className="table align-middle table-nowrap table-check table-list">

                                        <thead className="table-sales-gradient">
                                            <tr>
                                                <th style={{ width: '20px' }} className="align-middle">
                                                    <div className="form-check font-size-16">
                                                        <input className="form-check-input" type="checkbox" id="checkAll" />
                                                        <label className="form-check-label" htmlFor="checkAll"></label>
                                                    </div>
                                                </th>
                                                <th className="align-middle">#</th>

                                                <th className="align-middle"> Name</th>
                                                <th className="align-middle"> URL</th>
                                                <th className="align-middle">Two Factor Authentication</th>

                                                <th className="">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(Tenants) && Tenants.length > 0 ? (
                                                Tenants.map((tenanttype, index) => (
                                                    <tr key={tenanttype.id}>
                                                        <td>
                                                            <div className="form-check font-size-16">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`instanceCheck${index}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`instanceCheck${index}`}
                                                                ></label>
                                                            </div>
                                                        </td>
                                                        <td>{index + 1}</td>

                                                        <td>{tenanttype.name}</td>
                                                        <td>{tenanttype.url}</td>
                                                        <td>
                                                            {tenanttype.auth === 'true' || tenanttype.auth === true
                                                                ? <span className="badge bg-success bg-soft text-success">Enabled</span>
                                                                : <span className="badge bg-danger bg-soft text-danger">Disabled</span>}
                                                        </td>



                                                        {/* <td>{tenanttype.category?.name}</td> */}
                                                        {/* <td>{tenanttype.status === 1 ? 'Active' : 'Inactive'}</td> */}
                                                        {/* <td>{tenanttype.created_at}</td> */}
                                                        {/* <td>{tenanttype.updated_at}</td> */}
                                                        {/* <td>{tenanttype.created_by}</td> */}

                                                        {/* <td>{tenanttype.updated_by}</td> */}

                                                        <td>
                                                            <div className="dropdown">
                                                                <i
                                                                    className="mdi mdi-dots-horizontal font-size-18"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                    style={{ cursor: 'pointer' }}
                                                                ></i>
                                                                <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                    <li><WithEditPermission>
                                                                        <button className="dropdown-item" onClick={() => handleEditExpenseType(tenanttype)}>
                                                                            Edit
                                                                        </button></WithEditPermission>
                                                                    </li>
                                                                    <li><WithDeletePermission>
                                                                        <button className="dropdown-item" onClick={() => handleDelete(tenanttype.id)}>
                                                                            Delete
                                                                        </button></WithDeletePermission>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center">
                                                        No Tenants found.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageChange}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                    {/* Modal for Add/Edit ExpenseType */}
                                    <Offcanvas show={showModal} onHide={() => setShowModal(false)} placement='end' style={{ width: '480px' }}>
                                        <Offcanvas.Header closeButton>
                                            <Offcanvas.Title>{isEdit ? 'Edit Tenant' : 'Add Tenant'}</Offcanvas.Title>
                                        </Offcanvas.Header>
                                        <hr style={{ margin: 0 }} /><br />

                                        <Offcanvas.Body>
                                            <Form>
                                                <Form.Group controlId="tenantCategory" className="mb-3">
                                                    <Form.Label style={{ fontSize: '13px' }}>Name</Form.Label>
                                                    <Form.Control type="text" name="name" style={{ fontSize: '13px' }} value={formData.name} onChange={handleInputChange}
                                                        className={`form-control ${errors?.name ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>}

                                                </Form.Group><br/>

                                                <Form.Group controlId="tenanttypeName" className="mb-3">
                                                    <Form.Label style={{ fontSize: '13px' }}>URL</Form.Label>
                                                    <Form.Control type="text" name="url" style={{ fontSize: '13px' }} value={formData.url} onChange={handleInputChange}
                                                        className='form-control'
                                                    />

                                                </Form.Group><br/>

                                                <Form.Group controlId="twoFactorAuth" className="mb-3">
                                                    <Form.Label style={{ fontSize: '13px' }}>Two Factor Authentication</Form.Label>
                                                    <Form.Check
                                                        type="switch"
                                                        id="twoFactorAuth-switch"
                                                        label={formData.auth ? 'Enabled' : 'Disabled'}
                                                        checked={formData.auth}
                                                        onChange={(e) => setFormData(prev => ({
                                                            ...prev,
                                                            auth: e.target.checked
                                                        }))}
                                                    />
                                                </Form.Group><br/>







                                            </Form>
                                        </Offcanvas.Body>
                                        <div className="p-3 d-flex justify-content-end border-top">
                                            <Button variant="secondary me-2" onClick={() => setShowModal(false)}>Close</Button>
                                            <Button variant="secondary" onClick={handleSubmit}>{isEdit ? 'Update' : 'Save'} </Button>
                                        </div>
                                    </Offcanvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SystemTenant;

